import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vuedraggable from 'vuedraggable';
export default {
  name: 'layer',
  inject: ["contain"],
  provide: function provide() {
    return {
      contain: this.contain
    };
  },
  components: {
    draggable: vuedraggable
  },
  props: {
    count: {
      type: Number,
      default: 1
    },
    nav: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    handleGetActive: function handleGetActive(item) {
      return this.contain.active.includes(item.index);
    },
    handleSetActive: function handleSetActive(item) {
      if (item.children) {
        var list = item.children.map(function (ele) {
          return ele.index;
        });
        this.contain.selectNav(list);
      } else {
        this.contain.selectNav(item.index);
      }
    },
    hangeChangeName: function hangeChangeName(item) {
      this.$set(item, 'isname', !item.isname);
    },
    openFolder: function openFolder(item) {
      this.$set(item, 'menu', !item.menu);
      item.isname = false;
    }
  }
};